<template>
  <SimpleDataWithVariation
    :request-status="requestStatus"
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';

export default {
  name: 'SentimentIndex',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
      requestStatus: 'loading',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringOverview',
      })
        .then(response => {
          this.value = response.net_sentiment_score.toFixed(2);
          this.comparationValue = this.formatComparationValue(response.previous_net_sentiment_score);
          this.variation = this.getVariation(this.value, this.comparationValue);
          this.rawVariation = this.getVariation(this.value, this.comparationValue);
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
    getVariation(now, before) {
      const divideNumber = 100;
      const formattedNow = parseFloat(now);

      const shouldReturnZero = formattedNow === before || before === 0;
      if (shouldReturnZero) return 0;

      const diference = formattedNow - before;
      return (diference / Math.abs(before)) * divideNumber;
    },
    formatComparationValue(value) {
      const formattedValue = parseFloat(formatSocialNumberWithDecimal(value)).toFixed(2) / 100;
      return formattedValue;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
